// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-dataset-modal-pbhq0_ .semi-form-field{padding-top:0;padding-bottom:24px!important}.create-dataset-modal-pbhq0_ .semi-form-field-label{color:var(--coz-fg-secondary);margin-bottom:0;padding:0 8px 6px;font-size:12px;font-style:normal;font-weight:500;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-dataset-modal": `create-dataset-modal-pbhq0_`,
	"createDatasetModal": `create-dataset-modal-pbhq0_`
};
export default ___CSS_LOADER_EXPORT___;
